import React from "react";

import { Typography, Tooltip } from "clearsense-ui/components";

const FieldTooltip = ({ cde_source_system, cde_updated_date, children }) => (
  <Tooltip
    followCursor="horizontal"
    theme="light"
    content={
      <div className="flex flex-col p-2 space-y-1">
        <Typography style="medium">
          {"CDE Source System: "}
          <span className="text-primary-shade">{cde_source_system}</span>
        </Typography>
        <Typography style="medium">
          {"CDE Updated Date: "}
          <span className="text-primary-shade">{cde_updated_date}</span>
        </Typography>
      </div>
    }
    position="top"
  >
    <span className="cursor-default">{children}</span>
  </Tooltip>
);

export default FieldTooltip;
